import { query } from './query'
import { getBookingApiRoute } from '../helpers/bookingApiRoutes'

async function getMasterBookingExtras() {
    const url = getBookingApiRoute('getMasterBookingExtrasRoute')
    return await query(url)
}

export { getMasterBookingExtras }
